import * as Actions from '../actionsgazeta';

const initialState = {};

const programaItens = function (state = initialState, action) {
    switch (action.type) {
        case Actions.SET_PROGRAMA_ITENS_DATA:
            {
                return action.payload

            }
        case Actions.CLEAR_PROGRAMAM_ITENS_DATA:
            {
                return state;
            }
        default:
            {
                return state
            }
    }
};

export default programaItens;
